


















































































// @ts-nocheck
import Vue from 'vue';
import { ResultStore } from '@/store/index';
import { url, biHottag } from '@tencent/ppd-base-libs';
import charity from '@/business/charity';
import { hideLoading, showLoading } from '@/fit-components/loading/main';
import GuideDownloadImgVue from '@/components/guide-download-img.vue';
import GuideDownloadTmp from '@/components/guide-download-tmp.vue';
import { isTencentCharity, isTencentCharityProject, safeDecodeURIComponent } from '@/business/helper';
import { getOrganByOid } from '@/business/cfg';
import { isShowDapuHelp } from '@/business/limited-config';
import { Button, Divider } from '@tencent/wphk-design';

export default Vue.extend({
  name: 'result',
  data() {
    return {
      ResultStore,
      product_id: '',
      organization_id: '',
      donor_name: '',
      donor_email: '',
      donor_phone: '',
      amount: '',
      listid: '',
      isShowGuideDownloadImg: false,
      isLoading: true,
      nickname: '小紅花',
    };
  },
  components: {
    Button,
    Divider,
    GuideDownloadImgVue,
    GuideDownloadTmp,
  },
  async activated() {
    this.isLoading = true;
    let recordItem = sessionStorage.getItem('from_record_item');
    if (recordItem) {
      recordItem = JSON.parse(recordItem);
      showLoading();
      await charity.detailQry(recordItem);
      hideLoading();

      sessionStorage.setItem('from_record_item', '');
      biHottag('wallet.charity.histroydetail.index_view');
    } else if (url.getUrlParam('listid')) {
      showLoading();
      await charity.handlePayCallback();
      hideLoading();

      this.getDownloadImg();
    }
    this.isLoading = false;
  },
  deactivated() {
    this.isLoading = true;
    ResultStore.img = '';
    ResultStore.title = '';
    ResultStore.product_id = '';
    ResultStore.organization_id = '';
    ResultStore.oname = '';
    ResultStore.donor_name = '';
    ResultStore.donor_email = '';
    ResultStore.donor_phone = '';
    ResultStore.amount = '';
    ResultStore.listid = '';
    ResultStore.state = '';
    ResultStore.transaction_id = '';
    ResultStore.pay_time = '';
    ResultStore.isNineProj = false;
  },
  mounted() {
  },
  computed: {
    // 判断是否显示限时图片
    isShowLimitedTimeImg() {
      return isShowDapuHelp();
    },
  },
  methods: {
    safeDecodeURIComponent,
    getOrganByOid,
    getLogoStyle(url: string) {
      return {
        backgroundSize: '100% 100%',
        backgroundImage: `url(${url})`,
      };
    },
    returnHome() {
      if (!url.getUrlParam('listid')) {
        biHottag('wallet.charity.histroydetail.go_index_click');
      }
      setTimeout(() => {
        location.href = '/charity/index.shtml';
      }, 100);
    },
    handleCloseDownloadImg() {
      this.isShowGuideDownloadImg = false;
    },
    getDownloadImg() {
      // 只有在99公益日才展示
      if (isTencentCharity() && isTencentCharityProject(ResultStore.isNineProj)) {
        charity.getUserInfo().then((userInfo) => {
          if (userInfo.nickname) {
            this.nickname = userInfo.nickname;
          }
          this.isShowGuideDownloadImg = true;
        })
          .catch(() => {
          // 如果没授权，也能展示
            this.isShowGuideDownloadImg = true;
          });
      }
    },
  },

});
